import Switch from 'react-switch';
import { TableName } from 'src/modules/Catalog/pages/Products/components/TableName/tableName';
import {
  INVENTORY,
  INVENTORY_TOOLTIP,
} from 'src/modules/Catalog/labels/labels';

import { uncheckedWraper, checkedWraper } from './utils/iconStyles';

const publishedColumnName = (
  <TableName tooltip={INVENTORY_TOOLTIP} label={INVENTORY} />
);

const actOnChange = ({ checked, productStatus, token, setVariant, row }) => {
  if (productStatus !== 'draft') {
    setVariant({
      productID: row.product_id,
      variantID: row.id,
      action: checked ? 'activate' : 'deactivate',
      token,
    });
  }
};

const renderPublishedStatus = ({ row, productStatus, token, setVariant }) => (
  <td className="w-100">
    <div className="d-flex justify-content-center">
      <Switch
        disabled={productStatus === 'draft'}
        width={70}
        onColor="#222222"
        offColor="#F2F2F2"
        onHandleColor="#222222"
        offHandleColor="#222222"
        checked={
          row.inventory_policy === 'continue' && productStatus === 'active'
        }
        onChange={checked =>
          actOnChange({ checked, productStatus, token, setVariant, row })
        }
        uncheckedIcon={uncheckedWraper}
        checkedIcon={checkedWraper}
      />
    </div>
  </td>
);

const getPublishedStatusColumn = ({ productStatus, token, setVariant }) => ({
  name: publishedColumnName,
  cell: row => renderPublishedStatus({ row, productStatus, token, setVariant }),
  grow: 2,
  center: true,
});

export default getPublishedStatusColumn;
